jQuery.noConflict();
(($) => {
  $('input[type=submit]').on('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    $('#statusmessage').text('');
    let input = $('input[name=token]');
    let token = input.val();
    if(!token) return false;

    let modal = $('#dataroom');
    let url = '//cloud.dr-kehrer.com/index.php/s/' + token;

    $.ajax({
      url: url,
      success: (data) => {
        let ovl = $('<div id="dataroom" class="p-md-5 d-flex vh-100 vw-100 bg-dark bg-opacity-75" />')
        let wrapper = $('<div class="position-relative flex-grow-1" />')
        let iframe = $('<iframe src="'+url+'" style="width: 100%; height: 100%;" />')
        input.val('');

        ovl.append(wrapper.append(iframe));
        $('body').append(ovl);
        ovl.on('click', (e) => {
          ovl.remove();
        });
      },
      error: () => {
        $('#statusmessage').text('Dieser Zugangscode existiert nicht.');
      },
      dataType: 'html'
    });

    // modal.show();
  })
})(jQuery)